import { Box, Row } from "@stenajs-webui/core";
import { ModalCloseButton } from "@stenajs-webui/modal";
import cx from "classnames";
import type { ReactNode } from "react";

import styles from "./ModalHeaderContainer.module.css";

interface ModalHeaderContainerProps {
  children: ReactNode;
  className?: string;
  onRequestClose: () => void;
  sticky?: boolean;
}

export function ModalHeaderContainer({
  children,
  className,
  onRequestClose,
  sticky = true,
}: ModalHeaderContainerProps) {
  return (
    <Row
      className={cx(className, styles.modalHeaderContainer, {
        [styles.sticky]: sticky,
      })}
      gap={2}
    >
      <Box width={48} display={["block", null, "none"]} />
      <Box
        gap={2}
        flexDirection={["column", null, "row"]}
        alignItems={"center"}
        width={"100%"}
      >
        {children}
      </Box>
      <ModalCloseButton onClick={onRequestClose} aria-label={"Close"} />
    </Row>
  );
}
